export enum RolesHelper {
  PM = 'PM',
  MEMBRE_3P = 'MEMBRE_3P',
  RESP_3P = 'RESP_3P',
  INCA = 'INCA',
  IT_ADMIN = 'IT_ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN'
}


export enum ProjectStatusHelper {
  INITIATED = 'INITIATED',
  AFFECTED = 'AFFECTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  PENDING_BUSINESS_VALIDATION = 'PENDING_BUSINESS_VALIDATION',
  BUSINESS_VALIDATED = 'BUSINESS_VALIDATED',
  DONE = 'DONE',
  ARCHIVED = 'ARCHIVED',
  ABANDONED = 'ABANDONED',
  BY_DESGIN_MISSING = 'BY_DESGIN_MISSING',
}

export enum QuestionnaireCategories {
  context = 'context',
  data_description = 'data_description',
  data_protection = 'data_protection',
  pdp_compliance = 'pdp_compliance',
  data_retention = 'data_retention',
  deepening = 'deepening',
  action_plan = 'action_plan',
}

export enum QuestionTypes {
  text = 'text',
  textarea = 'textarea',
  select = 'select',
  select_multiple = 'select_multiple',
  radio = 'radio',
  checkbox = 'checkbox',
  date = 'date',
  chips = 'chips',
  user = 'user',
  users_list = 'users_list',
}

export enum AttentionPoints {
  AP001 = 'AP001',
  AP002 = 'AP002',
  AP003 = 'AP003',
  AP004 = 'AP004',
  AP005 = 'AP005',
  AP006 = 'AP006',
  AP007 = 'AP007',
  AP008 = 'AP008',
  AP009 = 'AP009',
}

export enum ActionPlanStatus {
  TODO = 'TODO',
  PENDING = 'PENDING',
  ACCOMPLISHED = 'ACCOMPLISHED'
}

export enum Actions {
  ACT001 = 'ACT001',
  ACT002 = 'ACT002',
  ACT003 = 'ACT003',
  ACT004 = 'ACT004',
  ACT005 = 'ACT005',
  ACT006 = 'ACT006',
  ACT007 = 'ACT007',
  ACT008 = 'ACT008',
  ACT009 = 'ACT009',
  ACT010 = 'ACT010',
  ACT011 = 'ACT011',
  ACT012 = 'ACT012',
  ACT013 = 'ACT013',
  ACT014 = 'ACT014',
  ACT015 = 'ACT015',
  ACT016 = 'ACT016',
  ACT017 = 'ACT017',
  ACT018 = 'ACT018',
  ACT019 = 'ACT019',
  ACT020 = 'ACT020',
  ACT021 = 'ACT021',
  ACT022 = 'ACT022',
  ACT023 = 'ACT023',
  ACT024 = 'ACT024',
  ACT025 = 'ACT025',
  ACT026 = 'ACT026',
  ACT027 = 'ACT027',
  ACT028 = 'ACT028',
  ACT029 = 'ACT029',
  ACT030 = 'ACT030',
  ACT031 = 'ACT031',
  ACT032 = 'ACT032',
  ACT033 = 'ACT033',
  ACT034 = 'ACT034',
  ACT035 = 'ACT035',
  ACT036 = 'ACT036',
  ACT037 = 'ACT037',
  ACT038 = 'ACT038',
  ACT039 = 'ACT039',
  ACT040 = 'ACT040',
  ACT041 = 'ACT041',
  ACT042 = 'ACT042',
  ACT043 = 'ACT043',
  ACT044 = 'ACT044',
  ACT045 = 'ACT045',
  ACT046 = 'ACT046',
  ACT047 = 'ACT047',
  ACT048 = 'ACT048',
  ACT049 = 'ACT049',
  ACT050 = 'ACT050',
  ACT051 = 'ACT051',
  ACT052 = 'ACT052',
  ACT053 = 'ACT053',
  ACT054 = 'ACT054',
  ACT055 = 'ACT055',
  ACT056 = 'ACT056',
  ACT057 = 'ACT057',
  ACT058 = 'ACT058',
  ACT059 = 'ACT059',
  ACT060 = 'ACT060',
  ACT061 = 'ACT061',
  ACT062 = 'ACT062',
  ACT063 = 'ACT063',
  ACT064 = 'ACT064',
  ACT065 = 'ACT065',
  ACT066 = 'ACT066',
  ACT067 = 'ACT067',
  ACT068 = 'ACT068',
  ACT069 = 'ACT069',
  ACT070 = 'ACT070',
  ACT071 = 'ACT071',
  ACT072 = 'ACT072',
  ACT073 = 'ACT073',
  ACT074 = 'ACT074',
  ACT075 = 'ACT075',
  ACT076 = 'ACT076',
  ACT077 = 'ACT077',
}

export enum ActionRequirements {
  required = 'required',
  not_required = 'not_required',
  required_if_b2c = 'required_if_b2c'
}
